module.exports = __webpack_public_path__ + "static/media/RHE45M.76b759d5.jpg";